export enum DocsApiErrorCode {
    CommitIdOutOfSync = 250_000,
    InsufficientPermissions = 2011,
    Unknown = 0,
}
